/* eslint-disable @typescript-eslint/no-var-requires */
import defaultSEO from './default.json';
import { seoT } from './types';
import usSEO from './US.json';
import auSEO from './AU.json';
import settings from '@/settings';

let seo: Partial<seoT> = defaultSEO;

if (settings.store === 'reebelo-us') seo = usSEO;
if (['reebelo-au', 'reebelo-nz'].includes(settings.store)) seo = auSEO;

export default seo as seoT;
